import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Car } from "../_models/car";
import { AuthenticationService } from "../_services/authentication.service";
import { EnvironmentService } from "./index";
import { ServiceOffer } from "../_models/serviceoffer";

@Injectable()
export class CarsService {
  private baseUrl: string = this.environmentService.getBaseURL() + "/api";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getAll(): Observable<Car[]> {
    let cars$ = this.http
      .get(`${this.baseUrl}/cars`, this.makeHeaders())
      .map(mapCars)
      .catch(handleError);
    return cars$;
  }

  // new change -- add function for get dealer cars
  getDealer(id: string): Observable<Car[]> {
    let cars$ = this.http
      .get(`${this.baseUrl}/cars?dealer_id=${id}`, this.makeHeaders())
      .map(mapCars)
      .catch(handleError);
    return cars$;
  }

  getUsedCars(
    id: string
  ): Observable<{ details: Car; prices: ServiceOffer[] }> {
    let cars$ = this.http
      .get(`${this.baseUrl}/used-cars/${id}`, this.makeHeaders())
      .map((response: Response) => response.json())
      .catch(handleError);
    return cars$[0];
  }

  get(id: string): Observable<Car> {
    let car$ = this.http
      .get(`${this.baseUrl}/cars/${id}`, this.makeHeaders())
      .map(mapCar);
    return car$;
  }
  // save(person: Person) : Observable<Response>{
  //   // this won't actually work because the StarWars API doesn't
  //   // is read-only. But it would look like this:
  //   return this.http
  //     .put(`${this.baseUrl}/people/${person.id}`, JSON.stringify(person), {headers: this.getHeaders()});
  // }
  save(car: Car): Observable<Response> {
    // this won't actually work because the StarWars API doesn't
    // is read-only. But it would look like this:
    return this.http.put(
      `${this.baseUrl}/cars/${car._id}`,
      JSON.stringify(car),
      this.makeHeaders()
    );
  }

  saveCar(car: Car): Observable<Response> {
    // this won't actually work because the StarWars API doesn't
    // is read-only. But it would look like this:
    return this.http.put(
      `${this.baseUrl}/cars/${car._id}`,
      JSON.stringify(car),
      this.makeHeaders()
    );
  }

  create(car: Car): Observable<Car> {
    let newcar = this.http
      .post(`${this.baseUrl}/cars`, JSON.stringify(car), this.makeHeaders())
      .map(mapCar);
    return newcar;
  }

  clone(carToBeCloned: Car, clone: Car): Observable<Car> {
    return this.http
      .post(
        `${this.baseUrl}/cars/${clone._id}/clone`,
        JSON.stringify(carToBeCloned),
        this.makeHeaders()
      )
      .map(mapCar);
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapCars(response: Response): Car[] {
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  return response.json().map(toCar);
}

function toCar(r: any): Car {
  let car = <Car>{
    _id: r._id,
    carmake: r.carmake,
    carmodel: r.carmodel,
    carmodelcode: r.carmodelcode,
    carversion: r.carversion,
    chassisnumberpattern: r.chassisnumberpattern,
    dealer_id: r.dealer_id,
    externalcarid: r.externalcarid,
    modelyear: r.modelyear ? r.modelyear : null,
    kmPerService: r.kmPerService ? r.kmPerService : null,
    yearsPerService: r.yearsPerService ? r.yearsPerService : null
  };
  // console.log('Parsed car:', car);
  return car;
}

function mapCar(response: Response): Car {
  // toPerson looks just like in the previous example
  return toCar(response.json());
}

// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/cars.service.ts